import { createSelector } from 'reselect'

import { PostingRootState } from '../postingRoot.reducer'

export const getLinkedInFeeds = createSelector(
  (state: PostingRootState) => state.linkedInStore.linkedInFeeds,
  (state) => state,
)

